module.exports = __webpack_public_path__ + "img/slider_16.c131806a.jpg";